module.exports = __webpack_public_path__ + "media/images/signature-abc-45223ca4c4be15d270ca711f9759ba2f.png";